import { Chip } from '@mui/material';
import { DatasourceStatus } from '../../model/types';

const STATUS_COLOR_MAP: Record<
  DatasourceStatus,
  {
    backgroundColor: string;
    color: string;
  }
> = {
  [DatasourceStatus.error]: {
    backgroundColor: 'error.main',
    color: 'white',
  },
  [DatasourceStatus.active]: {
    backgroundColor: '#198754',
    color: 'white',
  },
  [DatasourceStatus.inactive]: {
    backgroundColor: '#E7ECFA',
    color: '#646874',
  },
};
const LABELS: Record<DatasourceStatus, string> = {
  [DatasourceStatus.active]: 'Connected',
  [DatasourceStatus.error]: 'Error',
  [DatasourceStatus.inactive]: 'Not Connected',
};

interface Props {
  status: DatasourceStatus;
}

export function StatusIndicator({ status }: Props) {
  return (
    <Chip
      sx={{
        height: 22,
        fontSize: '0.75rem',
        lineHeight: '0.875rem',
        ...STATUS_COLOR_MAP[status],
      }}
      size="small"
      label={LABELS[status]}
    />
  );
}
